import React from 'react';
import { Breadcrumb } from '../../pages/runtime-typechecker';
import style from './BreadCrumb.module.css';
import { Helmet } from 'react-helmet';

type BreadCrumbsProps = {
  breadcrumb: Breadcrumb[];
  visible?: boolean;
};

export default function BreadCrumbs({
  breadcrumb = [],
  visible = true
}: BreadCrumbsProps) {
  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {`
          {
          "@context": "http://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": ${JSON.stringify(
            breadcrumb.map((b, idx) => ({
              '@type': 'ListItem',
              position: String(idx + 1),
              item: {
                '@type': 'WebPage',
                '@id': b.redirectionUrl || '',
                name: b.displayString
              }
            }))
          )}
          }
        `}
        </script>
      </Helmet>
      <div className="">
        {visible && (
          <ul className={style.breadCrumb}>
            {breadcrumb.map((c, idx) =>
              breadcrumb.length !== idx + 1 ? (
                <li key={c.redirectionUrl}>
                  <a href={c.redirectionUrl}>
                    <span itemProp="name">{c.displayString}</span>
                  </a>
                  &nbsp;&gt;&nbsp;
                </li>
              ) : (
                <li key="crntNode">
                  <span className={style.crntNode} itemProp="name">
                    {c.displayString}
                  </span>
                </li>
              )
            )}
          </ul>
        )}
      </div>
    </>
  );
}
